import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosResponse, HttpStatusCode } from "axios";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import { HeadersUtil } from "app/utils/headersUtil";
import { ResponseApi, ResponseResultCode } from "app/model/response-api";
import { DailyWeatherModel, WeatherModel } from "app/model/common/weatherModel";

interface ApiWeather {
  DG?: { today: WeatherModel[]; tomorrow: WeatherModel[] };
  week?: DailyWeatherModel[];
  updatedAt?: string | null;
}

interface StateModel {
  today: WeatherModel[];
  tomorrow: WeatherModel[];
  week: DailyWeatherModel[];
  updatedAt: string | null;
}

const initialState: StateModel = { today: [], tomorrow: [], week: [], updatedAt: null };

export const getWeather = createAsyncThunk("weather/weathers", async () => {
  const url = process.env.REACT_APP_URL_CO + "/weather";
  const res: AxiosResponse = await axios.get(ApiUrlUtil.buildQueryString(url), { headers: HeadersUtil.getHeadersAuth() });
  if (res?.status === HttpStatusCode.Ok) {
    const api: ResponseApi<ApiWeather> = res.data;
    if (api?.resultCode === ResponseResultCode.Y) return api.data;
  }
  return null;
});

const weatherSlice = createSlice({
  name: "weather",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getWeather.fulfilled, (state, action) => {
        const d = action.payload;
        if (!d) return; // 실패 시 기존 값 유지
        state.today = d.DG?.today ?? [];
        state.tomorrow = d.DG?.tomorrow ?? [];
        state.week = d.week ?? [];
        state.updatedAt = d.updatedAt ?? null;
      });
  },
});

export default weatherSlice.reducer;
